// ============================================
// CHANGEMENT DE MOT DE PASSE DEPUIS LES PARAMÈTRES
// ============================================
// Toujours par POST /auth/change-password (AdminApi.changePassword) : le
// serveur y incrémente tokenVersion, ce qui ferme les autres sessions, et
// rend de nouveaux jetons, enregistrés aussitôt. PUT /auth/me ne fait rien
// de tout cela : il ne doit plus servir au mot de passe.
// Le temps réel reprend ensuite avec le nouveau jeton (l'ancien ne vaut plus).

import { AdminApi } from '../../services/api';
import { adminSocketService } from '../../services/socket';

export async function changerMonMotDePasse(actuel: string, nouveau: string): Promise<void> {
  await AdminApi.changePassword(actuel, nouveau);
  adminSocketService.reconnecter();
}
